var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterface4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.25 53.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccd6e5;}.cls-2{fill:#b8bcc0;}.cls-3{fill:#9caab2;}.cls-4{fill:#343f42;}.cls-5,.cls-6{fill:#d0d6e1;}.cls-5,.cls-7{stroke:#343f42;stroke-miterlimit:10;}.cls-7{fill:none;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02a",
    "data-name": "Interface_02a",
    viewBox: "0 0 33.25 53.52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.6 17.52 0 2.16 6.65 0 33.25 15.36 26.6 17.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.25 51.36 33.25 15.36 26.6 17.52 26.6 53.52 33.25 51.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 2.16 26.6 17.52 26.6 53.52 0 38.16 0 2.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23.27 18.6 23.21 33.55 16.63 29.76 16.63 14.76 23.27 18.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "13.3 24.84 13.23 42.79 3.33 37.08 3.33 19.08 13.3 24.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.27 36.6 23.21 48.6 16.63 44.8 16.63 32.76 23.27 36.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.32,
    y1: 10.08,
    x2: 13.3,
    y2: 15.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.32,
    y1: 13.08,
    x2: 13.3,
    y2: 18.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.32,
    y1: 16.08,
    x2: 13.3,
    y2: 21.84
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 53.52,
    xlinkHref: "#Interface_02a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface4);
export default __webpack_public_path__ + "static/media/interface-4.2fc92519a5a7e39b9b803995c31c6c00.svg";
export { ForwardRef as ReactComponent };